import { Outlet } from "react-router-dom";
import TabBar from "./TabBar";

export const AppLayout = () => (
  <div className="mm-frame flex flex-col">
    <div className="flex-1 flex flex-col min-h-0">
      <Outlet />
    </div>
    <TabBar />
  </div>
);

export default AppLayout;
